import { PEDDING, SNAPING, DONE, REVERSING } from "@/config";
export const statusMixin = {
  data() {
    return {
      PEDDING, SNAPING, DONE, REVERSING
    }
  }
}